module.exports = __webpack_public_path__ + "img/5.698ba61d.jpg";